import { render, staticRenderFns } from "./CreateFormPage.vue?vue&type=template&id=52926826&scoped=true"
import script from "./CreateFormPage.vue?vue&type=script&lang=js"
export * from "./CreateFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52926826",
  null
  
)

export default component.exports